import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Transition = (props: IIcon) => {
  const { className = '', ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-8 h-8', className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7518 12.0594L21.733 23.1993L24.0769 20.8833C24.4523 20.5114 24.9596 20.3032 25.4879 20.3041C26.0163 20.3049 26.5228 20.5149 26.8969 20.888C27.082 21.0752 27.2283 21.2971 27.3274 21.5409C27.4265 21.7848 27.4765 22.0458 27.4746 22.309C27.4715 22.8337 27.2623 23.3361 26.8922 23.708L21.1226 29.4383C20.8431 29.7187 20.4866 29.9099 20.0984 29.9875C19.7102 30.0652 19.3077 30.0259 18.9418 29.8746C18.5768 29.724 18.2646 29.4687 18.0445 29.1409C17.8244 28.8131 17.7062 28.4274 17.7049 28.0326L17.7318 12.0326C17.7327 11.5022 17.9443 10.9938 18.32 10.6194C18.6957 10.2449 19.2048 10.0351 19.7352 10.036C20.2656 10.0368 20.774 10.2484 21.1484 10.6241C21.5229 10.9998 21.7327 11.5089 21.7318 12.0393L21.7518 12.0594ZM12.6081 2.32396C12.955 2.4852 13.2484 2.74255 13.4535 3.06548C13.6585 3.38841 13.7667 3.76337 13.7651 4.14591L13.7382 20.1459C13.7373 20.6763 13.5257 21.1847 13.15 21.5591C12.7743 21.9335 12.2652 22.1434 11.7348 22.1425C11.2044 22.1416 10.696 21.9301 10.3216 21.5544C9.94714 21.1786 9.73729 20.6696 9.73818 20.1392L9.75691 8.99917L7.43302 11.3153C7.05767 11.6871 6.55041 11.8954 6.02204 11.8945C5.49367 11.8936 4.98712 11.6837 4.61302 11.3105C4.24115 10.9352 4.03292 10.4279 4.03381 9.89955C4.03469 9.37118 4.24463 8.86463 4.61776 8.49053L10.3474 2.76015C10.6318 2.46754 10.9989 2.26892 11.3994 2.19095C11.8 2.11297 12.2147 2.15937 12.5881 2.32392L12.6081 2.32396Z"
        fill="#F48DB3"
      />
    </svg>
  );
};

export default Transition;
